import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':fieldReportId'}/fieldReportTypes/${number | ':fieldReportTypeId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:fieldReportId/fieldReportTypes/:fieldReportTypeId`;

export const URL = (fieldReportId: number, fieldReportTypeId: number): RouteDefinition =>
	`${baseRoute}/${fieldReportId}/fieldReportTypes/${fieldReportTypeId}`;
